import Api from "../axios";

export default async function apiEarlyLeaving(currentEmployeeId) {
  return await Api.get(`/auto_approve_list?employee_id=${currentEmployeeId}`);
}
